<script>
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";

export default {
  props: {
    parentId: {
      type: Number,
      required: true,
    },
    showSubtype: {
      type: Boolean,
    },
  },
  data() {
    return {
      multiple: false,
      submitted: false,
      tableData: [],
      selectedProcess: null,
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      form: {
        officeId: 0,
        processName: "",
        easeOfDoingBusinessType: "",
        estimatedWorkingDays: "",
        daysToRemindOfficeProcessor: "",
        parentProcessTypeId: 0,
      },
      indexSelected: -1,
      loading: false,
      selectedCampus: this.$store.state.data.selectedCampus.id,
    };
  },
  validations: {
    form: {
      processName: { required },
      easeOfDoingBusinessType: { required },
      estimatedWorkingDays: { required },
      daysToRemindOfficeProcessor: { required },
    },
  },
  computed: {
    maxEstimatedWorkingDays() {
      if (this.selectedProcess) {
        var count = 0;
        this.tableData.forEach((item) => {
          count = count + item.estimatedWorkingDays;
        });
        if (this.form.id) {
          var index = this.tableData.findIndex(
            (item) => item.id == this.form.id
          );
          count = count - this.tableData[index].estimatedWorkingDays;
        }
        return this.selectedProcess.estimatedWorkingDays - count;
      }
      return 0;
    },
    maxDaysToRemindOfficeProcessor() {
      if (this.selectedProcess) {
        var count = 0;
        this.tableData.forEach((item) => {
          count = count + item.daysToRemindOfficeProcessor;
        });
        if (this.form.id) {
          var index = this.tableData.findIndex(
            (item) => item.id == this.form.id
          );
          count = count - this.tableData[index].daysToRemindOfficeProcessor;
        }
        return this.selectedProcess.daysToRemindOfficeProcessor - count;
      }
      return 0;
    },
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.processName) {
            if (
              item.processName.toUpperCase().includes(this.filter.toUpperCase())
            )
              return item.processName
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
          if (item.easeOfDoingBusinessType) {
            if (
              item.easeOfDoingBusinessType
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            )
              return item.easeOfDoingBusinessType
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
        });
      }
      return data.sort(function (a, b) {
        if (a.processName < b.processName) {
          return -1;
        }
        if (a.processName > b.processName) {
          return 1;
        }
        return 0;
      });
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    },
  },
  methods: {
    getData(props) {
      this.loading = true;
      this.selectedProcess = null;
      this.selectedProcess = cloneDeep(props);
      this.$store
        .dispatch("dtsprocesstype/GetProcessTypeChild", props.id)
        .then((res) => {
          this.tableData = res.data;
          this.currentPage = 1;
          this.perPage = 10;
          this.filter = "";
          this.loading = false;
        });
    },
    onSubmit() {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      if (this.form.id) {
        this.$store
          .dispatch("dtsprocesstype/UpdateProcessType", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            var index = this.tableData.findIndex(
              (item) => item.id == this.form.id
            );
            this.tableData.splice(index, 1, this.form);
            this.$bvModal.hide(`modal-create-processSubtype-${this.parentId}`);
            this.showToast("Successfully updated!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.$store
          .dispatch("dtsprocesstype/CreateProcessType", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.tableData.push(res.data);
            this.$bvModal.hide(`modal-create-processSubtype-${this.parentId}`);
            this.showToast("Successfully created!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    addProcessType() {
      this.onReset();
      this.modalTitle = "Create Process Subtype";
      this.$bvModal.show(`modal-create-processSubtype-${this.parentId}`);
    },
    updateProcessType(props) {
      this.onReset();
      this.form = cloneDeep(props);
      this.modalTitle = "Update Process Subtype";
      this.$bvModal.show(`modal-create-processSubtype-${this.parentId}`);
    },
    deleteProcessType(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtsprocesstype/DeleteProcessType", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onReset() {
      this.submitted = false;
      this.form = {
        officeId: 0,
        processName: "",
        easeOfDoingBusinessType: this.selectedProcess.easeOfDoingBusinessType,
        estimatedWorkingDays: "",
        daysToRemindOfficeProcessor: "",
        parentProcessTypeId: this.selectedProcess.id,
      };
    },
    manageOffices(props) {
      this.$emit("manageOffices", props);
    },
    checkEstimatedWorkingDays() {
      if (
        parseFloat(this.form.estimatedWorkingDays) >
        parseFloat(this.maxEstimatedWorkingDays)
      ) {
        this.form.estimatedWorkingDays = this.maxEstimatedWorkingDays;
      } else if (
        this.form.estimatedWorkingDays == "" ||
        parseFloat(this.form.estimatedWorkingDays) < 0
      ) {
        this.form.estimatedWorkingDays = 0;
      }
    },
    checkDaysToRemindOfficeProcessor() {
      if (
        parseFloat(this.form.daysToRemindOfficeProcessor) >
        parseFloat(this.maxDaysToRemindOfficeProcessor)
      ) {
        this.form.daysToRemindOfficeProcessor =
          this.maxDaysToRemindOfficeProcessor;
      } else if (
        this.form.daysToRemindOfficeProcessor == "" ||
        parseFloat(this.form.daysToRemindOfficeProcessor) < 0
      ) {
        this.form.daysToRemindOfficeProcessor = 0;
      }
    },
  },
};
</script>
      
<template>
  <div>
    <b-collapse :visible="showSubtype" role="tabpanel">
      <div v-if="showSubtype">
        <!-- Main -->
        <div class="ps-5">
          <div class="d-flex flex-row-reverse mb-2">
            <button
              type="button"
              @click="addProcessType()"
              class="btn btn-sm btn-success d-flex align-items-center ms-1"
            >
              <i class="bx bx-plus fs-6 me-1"></i>Add Subtype
            </button>
          </div>
          <div class="d-flex justify-content-between mb-2">
            <b>Process Subtype</b>
            <div class="d-flex align-items-center">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Process Subtype..."
                    class="form-control form-control-sm"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <b-card v-if="loading">
            <div class="d-flex align-items-center justify-content-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
          </b-card>
          <b-card class="text-center" v-else-if="paginated.length == 0">
            <div v-if="filter != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no items
              matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No items available
            </div>
          </b-card>
          <div v-else class="text-muted">
            <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
              <b-card
                no-body
                class="m-0 mb-3 py-1"
                :style="`z-index: ${paginated.length - index + 10}`"
              >
                <b-card-header>
                  <div class="d-flex justify-content-between">
                    <div class="pe-3">{{ x.processName }}</div>
                    <div class="d-flex">
                      <div style="width: 220px" class="pe-3">
                        <div v-if="x.addedByOffice">
                          <div>{{ x.addedByOffice.name }}</div>
                          <small>{{ x.addedByOffice.campus }}</small>
                        </div>
                        <div v-else>Admin</div>
                      </div>
                      <div style="width: 200px" class="pe-3">
                        {{ x.easeOfDoingBusinessType }}
                      </div>
                      <div style="width: 180px" class="pe-3">
                        <small
                          >Estimated Working Days:
                          <b class="text-info">{{
                            x.estimatedWorkingDays
                          }}</b></small
                        >
                        <br />
                        <small
                          >Days to Remind Processor:
                          <b class="text-warning">{{
                            x.daysToRemindOfficeProcessor
                          }}</b></small
                        >
                      </div>
                      <div style="width: 60px">
                        <div class="d-flex justify-content-end">
                          <i
                            class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                            :id="`process-popover-${x.id}`"
                            tabindex="0"
                          ></i>
                          <b-popover
                            :target="`process-popover-${x.id}`"
                            triggers="click blur"
                            placement="leftbottom"
                            variant="secondary"
                            custom-class="p-0"
                          >
                            <b-list-group class="w-100 fit">
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-success"
                                @click="manageOffices(x)"
                                ><i class="bx bx-building font-size-18 me-1"></i
                                >Manage Office Access</b-list-group-item
                              >
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-info"
                                @click="updateProcessType(x)"
                                ><i class="bx bx-edit font-size-18 me-1"></i
                                >Update Process Subtype</b-list-group-item
                              >
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-danger"
                                @click="deleteProcessType(x)"
                                ><i class="bx bx-trash font-size-18 me-1"></i
                                >Delete Process Subtype</b-list-group-item
                              >
                            </b-list-group>
                          </b-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div v-if="rows > 0" class="col">
              Showing {{ (currentPage - 1) * perPage + 1 }} -
              {{
                rows > (currentPage - 1) * perPage + perPage
                  ? (currentPage - 1) * perPage + perPage
                  : rows
              }}
              of {{ rows }}
            </div>
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="z-index: -1"
                >
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
          <hr />
        </div>
        <!-- Create Process Subtype -->
        <b-modal
          :id="`modal-create-processSubtype-${parentId}`"
          :title="modalTitle"
          size="md"
          title-class="font-18"
          hide-footer
          no-close-on-backdrop
          no-close-on-esc
        >
          <form
            @submit.prevent="onSubmit"
            class="needs-validation"
            ref="targetForm"
          >
            <div class="mb-3">
              <label for="processName">Name </label>
              <input
                id="processName"
                type="text"
                v-model="form.processName"
                placeholder="Enter Name..."
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.form.processName.$error,
                }"
                autocomplete="off"
              />
              <div
                v-if="submitted && $v.form.processName.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.processName.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <div class="mb-3">
              <label for="estimatedWorkingDays">Estimated Working Days </label>
              <input
                id="estimatedWorkingDays"
                @input="checkEstimatedWorkingDays()"
                type="number"
                v-model="form.estimatedWorkingDays"
                :max="maxEstimatedWorkingDays"
                min="1"
                placeholder="Enter Estimated Working Days..."
                class="form-control"
                :class="{
                  'is-invalid':
                    submitted && $v.form.estimatedWorkingDays.$error,
                }"
                autocomplete="off"
              />
              <div
                v-if="submitted && $v.form.estimatedWorkingDays.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.estimatedWorkingDays.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <div class="mb-3">
              <label for="daysToRemindOfficeProcessor"
                >Days to Remind Office Processor
              </label>
              <input
                id="daysToRemindOfficeProcessor"
                @input="checkDaysToRemindOfficeProcessor()"
                type="number"
                v-model="form.daysToRemindOfficeProcessor"
                :max="maxDaysToRemindOfficeProcessor"
                min="1"
                placeholder="Enter Days to Remind Office Processor..."
                class="form-control"
                :class="{
                  'is-invalid':
                    submitted && $v.form.daysToRemindOfficeProcessor.$error,
                }"
                autocomplete="off"
              />
              <div
                v-if="submitted && $v.form.daysToRemindOfficeProcessor.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.daysToRemindOfficeProcessor.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <div class="d-flex float-end">
              <button type="submit" class="btn btn-primary">Submit</button>
            </div>
          </form>
        </b-modal>
      </div>
    </b-collapse>
  </div>
</template>